/**
 * Single source of truth for "account ready for billing" (Settings → Billing tab).
 * Must stay aligned with My Profile required fields (*), not optional registration #.
 */

export function mergeCompanyDataForSettings(userData = {}, companyRow = {}) {
  const fromCompany =
    companyRow && typeof companyRow === "object" && !Array.isArray(companyRow)
      ? { ...companyRow }
      : {};

  return {
    ...fromCompany,
    company_name:
      fromCompany.company_name || userData.company_name || "",
    company_phone:
      fromCompany.company_phone || userData.company_phone || "",
    company_tax_number:
      fromCompany.company_tax_number || userData.company_tax_number || "",
    company_address:
      fromCompany.company_address || userData.company_address || "",
    company_registration_number:
      fromCompany.company_registration_number ||
      userData.company_registration_number ||
      "",
  };
}

export function isAccountDataComplete(profileData = {}, companyData = {}) {
  const name = String(profileData?.name || "").trim();
  const companyName = String(companyData?.company_name || "").trim();
  const tax = String(companyData?.company_tax_number || "").trim();
  const phone = String(companyData?.company_phone || "").trim();
  const address = String(companyData?.company_address || "").trim();

  return Boolean(name && companyName && tax && phone && address);
}
